import React from "react";
import Home from "../../../components/Home/Home";

const LessonPlaner = () => {
  return (
    <div>
      <Home></Home>
    </div>
  );
};

export default LessonPlaner;
